import React from "react";
import { useNavigate } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";
import { formatDate } from "../../Utils/formatters";
import "./RecentMembers.css";

function RecentMembers({ data = [] }) {
  const navigate = useNavigate();

  const members = data.slice(0, 5);

  // ✅ Get Profile ID
  const getProfileId = (member) => {
    if (member.profile_id) return member.profile_id;
    if (member.user?.profile_id) return member.user.profile_id;
    if (member.staff_id) return member.staff_id;
    if (member.UserData?.profile_id) return member.UserData.profile_id;
    return '⚠️ Not Set';
  };

  // ✅ Get color based on role
  const getIdColor = (member) => {
    const role = (member.role || 'user').toLowerCase();
    const colorMap = {
      'admin': '#722ed1',
      'superadmin': '#eb2f96',
      'staff': '#1890ff',
      'user': '#ff0055',
    };
    return colorMap[role] || '#ff0055';
  };

  // ✅ Calculate Age from DOB
  const calculateAge = (member) => {
    if (member.age) return member.age;
    
    const dob = member.dob || 
                member.date_of_birth || 
                member.birth_date || 
                member.dateOfBirth ||
                member.DOB ||
                member.birthday ||
                member.user?.dob ||
                member.user?.date_of_birth ||
                member.UserData?.dob ||
                member.UserData?.date_of_birth;
    
    if (!dob) return 'N/A';
    
    try {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      
      return age > 0 ? age : 'N/A';
    } catch (error) {
      return 'N/A';
    }
  };

  if (members.length === 0) {
    return (
      <div className="recent-members-card">
        <div className="table-header">
          <h3 className="table-title">Recent Members</h3>
          {/* ✅ FIXED ROUTE */}
          <button className="view-all-btn" onClick={() => navigate("/admin/users")}>
            View All
          </button>
        </div>
        <div style={{ textAlign: "center", padding: "40px 20px", color: "#888" }}>
          <p>No members found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="recent-members-card">
      
      
      <div className="table-header">
        <h3 className="table-title">Recent Members</h3>
        {/* ✅ FIXED ROUTE */}
        <button className="view-all-btn" onClick={() => navigate("/admin/users")}>
          View All
        </button>
      </div>

      <div className="table-wrapper">
        <table className="recent-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Profile ID</th>
              <th>Name</th>
              <th>Gender</th>
              <th>Age</th>
              <th>City</th>
              <th>Joined Date</th>
              <th>Status</th>
              
            </tr>
          </thead>
          <tbody>
            {members.map((member, index) => (
              <tr key={member.id || index}>
                <td>{index + 1}</td>
                <td
                  className="ref-id"
                  style={{
                    color: getIdColor(member),
                    fontWeight: 700,
                    fontSize: 13,
                  }}
                >
                  {getProfileId(member)}
                </td>
                <td className="member-name">
                  {member.name || member.firstname || member.username || 'N/A'}
                </td>
                <td>{member.gender || 'N/A'}</td>
                <td>{calculateAge(member)}</td>
                <td>{member.city || 'N/A'}</td>
                <td>{formatDate(member.joinDate || member.created_date || member.create_date)}</td>
                <td>
                  <span className={`status-badge status-${member.status || 'active'}`}>
                    {member.status === "active" ? "Active" : member.status || "Active"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default RecentMembers;